import { createContext, useContext, useState, useEffect } from "react";

const translations = {
  de: {
    lang: "Deutsch",
    nav: { home: "Startseite", dashboard: "Dashboard", newProject: "Neues Projekt", profile: "Profil", contact: "Kontakt", login: "Anmelden", logout: "Abmelden", notifications: "Benachrichtigungen", browse: "Projekte ansehen" },
    roles: { client: "Auftraggeber", freelancer: "Auftragnehmer", other: "Sonstiges" },
    landing: {
      badge: "Project Radar AR",
      hero: "Vom Text-Briefing zur \"Deal-Ready\" Enterprise-Roadmap in Sekunden.",
      hero_bevor: "Deal-Ready",
      sub: "Zwischen einer IT-Vision als Idee (App, KI-Plattform, CRM-Modul, Cloud-Migration …) und dem konkreten Angebot zur Umsetzung verlieren Unternehmen Wochen. Briefings, Architektur, Budget, Compliance — jeder Schritt in einem anderen Tool, mit einem anderen Team. Wir nennen das die \"Discovery-Lücke\".",
      sub2: "Project Radar AR schließt die Lücke. Ein Text-Input — und unsere KI liefert in 90 Sekunden alles, was du für den Deal brauchst.",
      output_title: "Der vollständige Projekt-Output nach 90 Sekunden:",
      bullets: [
        { title: "Executive Summary & Meilensteine", desc: "Eine prägnante Management-Zusammenfassung und eine klare, zeitliche Meilenstein-Planung, die Ihren Projektfortschritt auf einen Blick strukturiert." },
        { title: "Interaktive 3D-Architektur", desc: "Eine visuelle High-Fidelity-Vorschau im Raum, die Frontend-Komponenten und komplexe Backend-Datenpipelines sofort greifbar und erlebbar macht." },
        { title: "Präzise Kalkulation", desc: "Eine vollautomatische, detaillierte Stunden- und Kostenaufschlüsselung, die Ihnen sofortige Budgettransparenz liefert." },
        { title: "Compliance-Native & Cloud-Mapping", desc: "Eine integrierte Risikoanalyse (z. B. nDSG/GDPR) inklusive automatischer Berechnung eines regulatorischen Audit-Puffers sowie native, optimierte Cloud-Architektur-Vorschläge (z. B. Google Cloud Platform)." },
        { title: "Empfohlene Technologien & System-Stack", desc: "Das System analysiert Ihre Anforderungen und mappt diese direkt auf den optimalen, zukunftssicheren Technologie-Stack (Datenbanken, Frameworks, APIs)." },
        { title: "Der optimale Benutzerflow", desc: "Ein logisch strukturierter Ablaufplan, der die Reise des Endnutzers durch Ihre geplante App oder Plattform Schritt für Schritt definiert." },
        { title: "Smart Contracting & Kollaboration", desc: "Die automatische Generierung eines unterschriftsreifen B2B-Dienstleistungsvertrags sowie ein interaktives Tool zur gemeinsamen Weiterentwicklung und Verfeinerung der IT-Lösung zwischen Auftraggeber und Auftragnehmer." },
      ],
      pill_exec: "Executive Summary",
      pill_3d: "3D-Architektur",
      pill_cost: "Kostenaufschlüsselung",
      pill_compliance: "Compliance-Puffer",
      pill_contract: "Smart Contract",
      cta_login: "Jetzt starten",
      cta_new: "Projekt erstellen",
      cta_dashboard: "Dashboard ansehen",
      problem_label: "Das Problem",
      problem_title_a: "Discovery kostet Wochen.",
      problem_title_b: "Wir machen Minuten daraus.",
      problem_text: '"Wir brauchen ein CRM-Modul." — Was folgt: 8 Meetings, 3 Angebote, 5 Excel-Sheets, 2 Anwaltsprüfungen. Am Ende sprechen alle über etwas anderes. Der Deal schmilzt, das Vertrauen bröckelt. Und niemand hat auch nur eine Zeile Code gesehen.',
      solution_label: "Die Lösung",
      solution_title_a: "Beschreib es.",
      solution_title_b: "Sieh es.",
      solution_title_c: "Verkauf es.",
      solution_text: 'Deine IT-Vision als Text — unsere KI orchestriert daraus eine interaktive 3D-Architektur, Kalkulation, Compliance-Check und Vertragsvorlage. In derselben Sitzung, in der du sie eingibst. Fertig zum Signieren.',
      value_label: "Der Mehrwert",
      value_title_a: "Ein Werkzeug,",
      value_title_b: "zwei Gewinner.",
      client_badge: "Für Auftraggeber",
      client_title: "Scope-Klarheit von Anfang an",
      client_b1_t: "Sieh, was Du beschreibst",
      client_b1_d: "Deine Textanforderung wird sofort visualisiert – Du erkennst auf einen Blick, ob Du wirklich 7 Seiten brauchst oder doch nur 5.",
      client_b2_t: "Weniger Missverständnisse",
      client_b2_d: "Das gemeinsame visuelle Modell stellt sicher, dass Du und Dein Auftragnehmer über dasselbe Produkt sprechen.",
      client_b3_t: "Präzisere Angebote",
      client_b3_d: "Datenbasierte Kalkulationen statt vager Schätzungen – Du kannst Angebote fair und transparent vergleichen.",
      client_b4_t: "Gemeinsam weiterentwickeln",
      client_b4_d: "Vom Briefing bis zum fertigen Produkt – Du und Dein Auftragnehmer arbeitet im selben 3D-Modell, mit Änderungsvorschlägen und Live-Chat. Schluss mit endlosem E-Mail-Pingpong.",
      free_badge: "Für Auftragnehmer",
      free_title: "Schneller kalkulieren, mehr gewinnen",
      free_b1_t: "Instant Scope-Assessment",
      free_b1_d: "Statt 30 Minuten Briefing lesen – in Sekunden siehst Du Screens, Funktionen und Komplexität im 3D-Modell.",
      free_b2_t: "Datenbasierte Kalkulation",
      free_b2_d: "Strukturierte Metadaten (Anzahl Screens, Komplexität, Stunden) fließen direkt in Dein Angebot ein.",
      free_b3_t: "Höhere Erfolgsquote",
      free_b3_d: "Schnellere und präzisere Angebote bedeuten mehr gewonnene Projekte – und weniger verschwendete Akquise-Zeit.",
      free_b4_t: "Direkte Zusammenarbeit",
      free_b4_d: "Du arbeitest gemeinsam mit dem Auftraggeber im 3D-Modell – Änderungsvorschläge, Live-Chat, klare Iterationen. Klarheit statt Annahmen, jederzeit.",
      feat_1_t: "3D-Projektvorschau",
      feat_1_d: "Interaktive Low-Fidelity Wireframes zeigen den Projektumfang auf einen Blick.",
      feat_2_t: "KI-gestützte Analyse",
      feat_2_d: "Automatische Erkennung von Komplexität, Tech-Stack und geschätztem Aufwand.",
      feat_3_t: "Präzise Kalkulation",
      feat_3_d: "Berechne Angebote basierend auf datengetriebenen Schätzungen statt Bauchgefühl.",
      cats_label: "Universal Solution Architect",
      cats_title_a: "Plane mit uns:",
      cats_title_b: "Apps · Cloud · AI · Security · Integration.",
      cats_sub: "Project Radar AR ist nicht nur für Apps. Wir planen die gesamte digitale Transformation deines Unternehmens — rechtssicher und visuell in 3D/AR.",
      cat_web_t: "Web-Anwendung", cat_web_d: "Website, Dashboard, E-Commerce, SaaS",
      cat_mobile_t: "Mobile App", cat_mobile_d: "iOS, Android, React Native, Flutter",
      cat_3d_t: "3D / CAD Projekt", cat_3d_d: "3D-Modellierung, Visualisierung, AR/VR",
      cat_cloud_t: "Cloud-Migration", cat_cloud_d: "Legacy → Cloud-native, DR, DB-Konsolidierung",
      cat_ai_t: "Data & AI Hub", cat_ai_d: "Data Warehouse, Custom AI Agents, IoT-Plattform",
      cat_sec_t: "Security & Compliance", cat_sec_d: "ISO / nDSG / GDPR-Audit, Cybersecurity-Hardening, IAM",
      cat_int_t: "Enterprise Integration", cat_int_d: "ERP / CRM-Konnektoren, Workflow-Automatisierung (iPaaS)",
      cat_more_t: "Weitere Vorhaben", cat_more_d: "Beschreibe dein Projekt – die KI passt sich an. Beliebige Branche, beliebige Tech-Stacks.",
      cats_cta_label: "Bereit?",
      cats_cta_text: "Wähle deine Kategorie und erhalte in 60 Sekunden eine vollständige KI-Roadmap.",
      cats_cta_btn: "Projekt starten",
      deliv_label: "Was Du bekommst",
      deliv_title_a: "Ein KI-Bericht ersetzt",
      deliv_title_b: "10 Briefing-Calls.",
      deliv_sub: "Jedes Projekt liefert sofort ein vollständiges Scoping-Dossier — 12 Bausteine für Klarheit, Kalkulation und Vertragsabschluss.",
      deliv: [
        { t: "Executive Summary", d: "5–7 Sätze Fließtext: welche konkreten Arbeiten in welcher Reihenfolge zur Zielerreichung notwendig sind." },
        { t: "3D-Projektvorschau", d: "Interaktive Three.js-Architektur mit klarer Frontend/Backend-Aufteilung, AR-fähig per QR-Code." },
        { t: "Benutzer-Flow", d: "Schritt-für-Schritt User Journey mit nummerierten Screens — vom App-Start bis zum Ziel." },
        { t: "Was der Benutzer sieht", d: "Frontend-Komponenten-Liste (Cyan-Plane) mit Beschreibung und Stundenaufwand pro Screen." },
        { t: "Was im Hintergrund läuft", d: "Backend-Module (Orange-Würfel): APIs, Datenbanken, Services — jedes mit Stunden- und Tage-Schätzung." },
        { t: "Empfohlene Technologien", d: "Konkreter Tech-Stack-Vorschlag (Frameworks, Datenbanken, Sprachen) basierend auf Projekt-Anforderungen." },
        { t: "Kostenaufschlüsselung", d: "Detaillierter Stundenaufwand pro Komponente mit Komplexitäts-Stufe — Basis für das Angebot." },
        { t: "Risikoanalyse", d: "2–5 konkrete Risiken (Performance, Compliance, externe APIs) mit Niedrig/Mittel/Hoch-Bewertung." },
        { t: "Regulatorischer Aufwand", d: "Branchen-Sensing (FINMA, HIPAA, MDR …) inkl. Audit-Puffer-Multiplikator und Divergenz-Hinweis." },
        { t: "Cloud-Architektur (GCP)", d: "Native-Service-Mapping pro Komponente — Apigee, Cloud KMS, Spanner, Cloud Run u. a." },
        { t: "Meilenstein-Planung", d: "3–5 Phasen mit Wochenzahl, zugehörigen Komponenten und Audit-Phase als kritischer Pfad." },
        { t: "Projekt-Zeitstrahl (Gantt)", d: "Visueller Gantt-Balken mit Lieferdatum, Personentagen und farb-codierten Phasen-Tracks." },
      ],
      contract_label: "Plus: Smart Contracts",
      contract_title: "Verträge auf Knopfdruck",
      contract_sub: "PDF & Word, automatisch mit jurisdiktionsspezifischen Klauseln (Schweiz, EU-DSGVO, Rom-I, IP-Rechte) — direkt aus dem Scoping-Dossier generiert.",
      contract_b1: "PDF & DOCX Export",
      contract_b2: "Automatische Klauseln nach Land",
      contract_b3: "Direkt unterschriftsreif",
      sponsor_label: "Unterstütze uns",
      sponsor_title: "Project Radar AR ist und bleibt kostenlos.",
      sponsor_sub: "Wir wollen die Entwicklung von IT-Projekten weltweit fördern — ohne Premium-Abos, ohne versteckte Kosten. Unser Ziel: faire, direkte und transparente Zusammenarbeit zwischen Auftraggebern und Auftragnehmern.",
      sponsor_b1: "Kostenfreie Nutzung für alle",
      sponsor_b2: "Keine Plattform-Provision auf Projekte",
      sponsor_b3: "Open für jede Branche, jede Größe, jedes Land",
      sponsor_cta_text: "Damit das so bleibt, ist jeder Unterstützungsbeitrag willkommen — egal ob 5€, 50€ oder 500€. Jeder Beitrag hilft uns, die Plattform zu pflegen, weiterzuentwickeln und unabhängig zu bleiben.",
      sponsor_button: "Mit PayPal unterstützen",
      sponsor_thanks: "Danke für deinen Beitrag zu einem fairen IT-Projektmarkt.",
    },
    dashboard: {
      title_client: "Meine Projekte",
      title_freelancer: "Verfuegbare Projekte",
      sub_client: "Verwalte deine erstellten Projekte",
      sub_freelancer: "Analysiere und kalkuliere Projekte",
      search: "Projekte durchsuchen...",
      filter: "Filter",
      all_categories: "Alle Kategorien",
      all_complexities: "Alle Komplexitaeten",
      reset_filters: "Filter zuruecksetzen",
      empty: "Noch keine Projekte",
      no_results: "Keine Ergebnisse",
      empty_client_hint: "Erstelle dein erstes Projekt.",
      empty_freelancer_hint: "Warte auf neue Projekte.",
      empty_filter_hint: "Versuche andere Suchbegriffe oder Filter.",
      new: "Neues Projekt",
      offer: "Angebot",
      preview_3d: "3D-Vorschau",
      complexity: "Komplexitaet",
      effort: "Aufwand",
    },
    auth: {
      login_title: "Melde dich an, um fortzufahren",
      register_title: "Erstelle ein neues Konto",
      tab_login: "Anmelden",
      tab_register: "Registrieren",
      name: "Name",
      role: "Rolle",
      email: "E-Mail",
      password: "Passwort",
      submit_login: "Anmelden",
      submit_register: "Konto erstellen",
      or: "oder",
      google: "Mit Google anmelden",
      forgot: "Passwort vergessen?",
      terms_pre: "Ich habe die",
      terms_link: "Nutzungsbedingungen",
      terms_post: "gelesen und akzeptiere sie vollumfänglich.",
      terms_required: "Bitte akzeptiere die Nutzungsbedingungen, um fortzufahren.",
      err_name: "Bitte gib deinen Namen ein.",
    },
    contractor_types: {
      label: "Auftragnehmer-Typ",
      hint: "Welche Art von Auftragnehmer bist du?",
      freelancer: "Freelancer",
      unternehmen: "Unternehmen",
      mitarbeiter_auftraggeber: "Mitarbeiter Auftraggeber",
      andere: "Andere",
    },
    contact: {
      badge: "Kontakt & Impressum",
      title_a: "Sprich mit uns –",
      title_b: "wir hören zu.",
      lead: "Fragen, Feedback, Bugs, Kooperationsanfragen? Ob Auftraggeber oder Auftragnehmer – wir antworten in der Regel innerhalb von 48 Stunden.",
      imprint_label: "Impressum",
      imprint_title: "Betreiber & Eigentuemer",
      owner: "Inhaber",
      address: "Adresse",
      email: "E-Mail",
      phone: "Telefon",
      legal: "Verantwortlich fuer den Inhalt gemaess Schweizer Recht. Alle Angaben ohne Gewaehr.",
      form_title: "Nachricht an den Betreiber",
      form_sub: "Fuer Auftraggeber und Auftragnehmer gleichermassen. Wir antworten auf jede Anfrage.",
      name: "Name",
      i_am: "Ich bin …",
      subject: "Betreff",
      subject_ph: "Worum geht es?",
      message: "Nachricht",
      message_ph: "Beschreibe dein Anliegen so genau wie moeglich…",
      submit: "Nachricht senden",
      success_t: "Danke! Deine Nachricht wurde gesendet.",
      success_d: "Wir melden uns innerhalb von 48 Stunden per E-Mail.",
      error: "Senden fehlgeschlagen. Bitte erneut versuchen.",
    },
    footer: {
      tagline: "Vom Text-Briefing zum 3D-Wireframe in Sekunden. Schluss mit vagen Scopes.",
      nav_label: "Navigation",
      operator: "Betreiber",
      imprint: "Impressum",
      terms: "Nutzungsbedingungen",
    },
    notif: {
      title: "Benachrichtigungen",
      new: "neu",
      mark_all: "Alle lesen",
      empty: "Keine Benachrichtigungen",
      empty_sub: "Neue Aktivitaeten erscheinen hier",
      loading: "Laedt...",
      time_now: "gerade eben",
      time_min: "vor {n} Min.",
      time_hour: "vor {n} Std.",
      time_day: "vor {n} T.",
    },
    wizard: { title: "Neues Projekt erstellen", step1: "Was soll entstehen?", step2: "Wen betrifft es?", step3: "Details beschreiben", step1_sub: "Waehle die Art deines Projekts", step2_sub: "Wer wird die Anwendung nutzen?", step3_sub: "Je detaillierter, desto genauer die Analyse", next: "Weiter", back: "Zurueck", analyze: "KI-Analyse starten", title_ph: "z.B. Bio-Kaffee Shop App", desc_ph: "Beschreibe was die App koennen soll, welche Features wichtig sind...", users_ph: "z.B. Endkunden, Mitarbeiter, Administratoren", audience: "Zielgruppe", projectTitle: "Projekttitel", description: "Projektbeschreibung", industry: "Branche", industry_hint: "fuer Compliance-Pass", industry_auto: "Automatisch erkennen (empfohlen)", ind_banking: "Banking / Finanzdienstleistungen", ind_insurance: "Versicherung", ind_healthcare: "Healthcare / Medizin", ind_pharma: "Pharma / Life Sciences", ind_government: "Government / Oeffentlicher Sektor / Defense", ind_energy: "Energy / Critical Infrastructure (KRITIS)", ind_telecom: "Telecom / Telekommunikation", ind_retail: "Retail / E-Commerce", ind_manufacturing: "Manufacturing / Industrie", ind_logistics: "Logistics / Transport", ind_education: "Education / Bildung", ind_media: "Media / Entertainment", ind_real_estate: "Real Estate / Immobilien", ind_consulting: "Consulting / Services", ind_other: "Andere / Nicht reguliert" },
    project: { back: "Zurueck zum Dashboard", edit: "Bearbeiten", pdf: "PDF", delete_confirm: "Projekt wirklich loeschen?", "3d_title": "3D-Projektvorschau", ar: "AR-Kamera", analysis: "Analyse-Dashboard", complexity: "Komplexitaet", hours: "Geschaetzter Aufwand", hours_unit: "Stunden", techstack: "Empfohlener Tech-Stack", elements: "Visuelle Elemente", screens: "Screens", functions: "Funktionen" },
    viz: { intro_title: "Was zeigt diese Vorschau?", intro_text: "Diese Analyse zeigt alle Bausteine, die fuer dieses Projekt entwickelt werden muessen.", cyan_label: "Cyan-Rechtecke", orange_label: "Orange-Wuerfel", cyan_desc: "= Seiten die der Benutzer sieht,", orange_desc: "= Technik die unsichtbar im Hintergrund laeuft.", zoom: "Mausrad: Zoomen | Ziehen: Drehen", screens_count: "Seiten die Benutzer sehen", backend_count: "Hintergrund-Systeme", total: "Komponenten gesamt", journey_title: "So navigiert der Benutzer durch die App", journey_sub: "Der typische Weg eines Benutzers von Anfang bis Ende:", frontend_title: "Was der Benutzer sieht", frontend_sub: "Seiten und Bildschirme der Anwendung", backend_title: "Was im Hintergrund laeuft", backend_sub: "Unsichtbare Technik, Datenbanken und Logik", connection: "So haengt alles zusammen:", connection_text: "Jede Seite (oben) kommuniziert mit den Hintergrund-Systemen (unten) um Daten zu laden, zu speichern und zu verarbeiten." },
    cost: { title: "Kostenaufschluesselung pro Komponente", sub: "Detaillierter Stundenaufwand fuer jede Komponente", component: "Komponente", hours: "Stunden", complexity: "Aufwand", total: "Gesamt" },
    risk: { title: "Risikoanalyse", sub: "Potenzielle Herausforderungen und Risiken", high: "Hoch", medium: "Mittel", low: "Niedrig" },
    milestone: { title: "Meilenstein-Planung", sub: "Projektphasen und Zeitrahmen", phase: "Phase", weeks: "Wochen", components: "Enthaltene Komponenten", total_weeks: "Gesamtdauer" },
    calc: { title: "Kalkulator", rate: "Dein Stundensatz (EUR)", avg: "Mittelwert Stunden", rate_label: "Stundensatz", total: "Gesamtpreis", send_offer: "Angebot basierend auf Analyse senden", offer_sent: "Angebot erfolgreich versendet!" },
    preview2d: { title: "UI-Vorschau", subtitle: "Zero-Cost CSS-Wireframe — keine KI-Generierung", tab_landing: "Landing", tab_dashboard: "Dashboard", tab_detail: "Detail", tab_form: "Formular", mode_desktop: "Desktop", mode_mobile: "Mobile", cta_show: "UI-Vorschau ansehen (erste Inspiration)", cta_hide: "Ausblenden", cta_open: "Öffnen", disclaimer: "AI-generierte Visualisierung deiner App. Diese Vorschau dient als <strong>Inspirations-Anker</strong>, nicht als Pflicht-Vorgabe. Dein Auftragnehmer wird daraus ein finales Design entwickeln, das technisch und visuell optimal zu deinen Anforderungen passt." },
    chat: { title: "Projekt-Chat", empty: "Noch keine Nachrichten. Starte die Konversation!", input: "Nachricht schreiben..." },
  },
  en: {
    lang: "English",
    nav: { home: "Home", dashboard: "Dashboard", newProject: "New Project", profile: "Profile", contact: "Contact", login: "Sign in", logout: "Sign out", notifications: "Notifications", browse: "Browse projects" },
    roles: { client: "Client", freelancer: "Contractor", other: "Other" },
    landing: {
      badge: "Project Radar AR",
      hero: "From text briefing to a \"Deal-Ready\" enterprise roadmap in seconds.",
      hero_bevor: "Deal-Ready",
      sub: "Between an IT vision as an idea (app, AI platform, CRM module, cloud migration …) and a concrete implementation quote, companies lose weeks. Briefing, architecture, budget, compliance — each step in a different tool with a different team. We call it the \"discovery gap\".",
      sub2: "Project Radar AR closes the gap. One text input — and our AI delivers, in 90 seconds, everything you need to close the deal.",
      output_title: "Your complete project output after 90 seconds:",
      bullets: [
        { title: "Executive Summary & Milestones", desc: "A concise management summary and a clear, time-based milestone plan that structures your project progress at a glance." },
        { title: "Interactive 3D Architecture", desc: "A high-fidelity visual preview in space that instantly makes frontend components and complex backend data pipelines tangible." },
        { title: "Precise Calculation", desc: "A fully automated, detailed hour- and cost breakdown that delivers immediate budget transparency." },
        { title: "Compliance-Native & Cloud Mapping", desc: "An integrated risk analysis (e.g. nDSG/GDPR) including automatic regulatory audit buffer calculation, plus native, optimized cloud architecture proposals (e.g. Google Cloud Platform)." },
        { title: "Recommended Technologies & System Stack", desc: "The system analyzes your requirements and maps them directly onto the optimal, future-proof technology stack (databases, frameworks, APIs)." },
        { title: "Optimal User Flow", desc: "A logically structured journey plan that defines the end-user's path through your planned app or platform step by step." },
        { title: "Smart Contracting & Collaboration", desc: "Automatic generation of a signature-ready B2B services contract plus an interactive tool for jointly refining the IT solution between client and contractor." },
      ],
      pill_exec: "Executive Summary",
      pill_3d: "3D Architecture",
      pill_cost: "Cost Breakdown",
      pill_compliance: "Compliance Buffer",
      pill_contract: "Smart Contract",
      cta_login: "Get started",
      cta_new: "Create project",
      cta_dashboard: "Open dashboard",
      problem_label: "The Problem",
      problem_title_a: "Discovery takes weeks.",
      problem_title_b: "We turn it into minutes.",
      problem_text: '"We need a CRM module." — What follows: 8 meetings, 3 quotes, 5 Excel sheets, 2 legal reviews. In the end, everyone is talking about something different. The deal cools off, trust erodes. And nobody has seen a single line of code.',
      solution_label: "The Solution",
      solution_title_a: "Describe it.",
      solution_title_b: "See it.",
      solution_title_c: "Sell it.",
      solution_text: 'Your IT vision as text — our AI orchestrates an interactive 3D architecture, cost calculation, compliance check and contract draft from it. In the same session you type it. Ready to sign.',
      value_label: "The Value",
      value_title_a: "One tool,",
      value_title_b: "two winners.",
      client_badge: "For Clients",
      client_title: "Scope clarity from day one",
      client_b1_t: "See what you describe",
      client_b1_d: "Your text requirement is instantly visualized – you see at a glance whether you actually need 7 pages or only 5.",
      client_b2_t: "Fewer misunderstandings",
      client_b2_d: "A shared visual model ensures you and your contractor talk about the same product.",
      client_b3_t: "More precise offers",
      client_b3_d: "Data-based calculations instead of gut estimates – you can compare proposals fairly and transparently.",
      client_b4_t: "Build it together",
      client_b4_d: "From briefing to finished product – you and your contractor iterate in the same 3D model, with change requests and live chat. No more endless email ping-pong.",
      free_badge: "For Contractors",
      free_title: "Quote faster, win more",
      free_b1_t: "Instant scope assessment",
      free_b1_d: "Instead of reading a 30-minute briefing – see screens, features and complexity in a 3D model in seconds.",
      free_b2_t: "Data-driven calculation",
      free_b2_d: "Structured metadata (screen count, complexity, hours) feeds directly into your proposal.",
      free_b3_t: "Higher win rate",
      free_b3_d: "Faster, more precise offers mean more won projects – and less wasted acquisition time.",
      free_b4_t: "Direct collaboration",
      free_b4_d: "Work hand-in-hand with the client in the same 3D model – change requests, live chat, clear iterations. Clarity instead of assumptions, anytime.",
      feat_1_t: "3D Project Preview",
      feat_1_d: "Interactive low-fidelity wireframes reveal the project scope at a glance.",
      feat_2_t: "AI-Powered Analysis",
      feat_2_d: "Automatic detection of complexity, tech stack and estimated effort.",
      feat_3_t: "Precise Pricing",
      feat_3_d: "Quote based on data-driven estimates instead of gut feeling.",
      cats_label: "Universal Solution Architect",
      cats_title_a: "Plan with us:",
      cats_title_b: "Apps · Cloud · AI · Security · Integration.",
      cats_sub: "Project Radar AR is not just for apps. We plan your entire digital transformation — legally sound and visually in 3D/AR.",
      cat_web_t: "Web Application", cat_web_d: "Website, Dashboard, E-Commerce, SaaS",
      cat_mobile_t: "Mobile App", cat_mobile_d: "iOS, Android, React Native, Flutter",
      cat_3d_t: "3D / CAD Project", cat_3d_d: "3D modeling, visualization, AR/VR",
      cat_cloud_t: "Cloud Migration", cat_cloud_d: "Legacy → cloud-native, DR, DB consolidation",
      cat_ai_t: "Data & AI Hub", cat_ai_d: "Data warehouse, custom AI agents, IoT platform",
      cat_sec_t: "Security & Compliance", cat_sec_d: "ISO / GDPR / SOC2 audit, cybersecurity hardening, IAM",
      cat_int_t: "Enterprise Integration", cat_int_d: "ERP / CRM connectors, workflow automation (iPaaS)",
      cat_more_t: "Anything else", cat_more_d: "Describe your project — the AI adapts. Any industry, any tech stack.",
      cats_cta_label: "Ready?",
      cats_cta_text: "Pick your category and get a full AI roadmap in 60 seconds.",
      cats_cta_btn: "Start Project",
      deliv_label: "What you get",
      deliv_title_a: "One AI report replaces",
      deliv_title_b: "10 briefing calls.",
      deliv_sub: "Every project instantly delivers a complete scoping dossier — 12 building blocks for clarity, costing and signing.",
      deliv: [
        { t: "Executive Summary", d: "5–7 sentences of prose explaining which concrete work in which order is needed to reach the goal." },
        { t: "3D Project Preview", d: "Interactive Three.js architecture with clear frontend/backend split, AR-ready via QR code." },
        { t: "User Flow", d: "Step-by-step user journey with numbered screens — from app launch to goal." },
        { t: "What the user sees", d: "Frontend components (cyan planes) with description and hours per screen." },
        { t: "What runs in the background", d: "Backend modules (orange cubes): APIs, databases, services — each with hour & day estimates." },
        { t: "Recommended tech stack", d: "Concrete tech-stack proposal (frameworks, databases, languages) tailored to the requirements." },
        { t: "Cost breakdown", d: "Detailed hour budget per component with complexity rating — the foundation for your quote." },
        { t: "Risk analysis", d: "2–5 concrete risks (performance, compliance, external APIs) rated Low / Medium / High." },
        { t: "Regulatory overhead", d: "Industry sensing (FINMA, HIPAA, MDR …) including audit-buffer multiplier and divergence warning." },
        { t: "Cloud architecture (GCP)", d: "Native service mapping per component — Apigee, Cloud KMS, Spanner, Cloud Run and more." },
        { t: "Milestone planning", d: "3–5 phases with week counts, included components and audit phase as critical path." },
        { t: "Project timeline (Gantt)", d: "Visual Gantt bar with delivery date, person-days and colour-coded phase tracks." },
      ],
      contract_label: "Plus: Smart Contracts",
      contract_title: "Contracts at the press of a button",
      contract_sub: "PDF & Word with jurisdiction-specific clauses baked in (Switzerland, EU GDPR, Rome I, IP rights) — generated directly from the scoping dossier.",
      contract_b1: "PDF & DOCX export",
      contract_b2: "Automatic clauses per country",
      contract_b3: "Signature-ready",
      sponsor_label: "Support us",
      sponsor_title: "Project Radar AR is — and stays — free.",
      sponsor_sub: "We want to advance IT projects worldwide — no premium plans, no hidden costs. Our goal: fair, direct, transparent collaboration between clients and contractors.",
      sponsor_b1: "Free for everyone",
      sponsor_b2: "No platform commission on projects",
      sponsor_b3: "Open to every industry, every size, every country",
      sponsor_cta_text: "To keep it that way, every contribution helps — whether 5€, 50€, or 500€. Every donation lets us maintain, evolve, and keep the platform independent.",
      sponsor_button: "Support via PayPal",
      sponsor_thanks: "Thank you for backing a fair IT project market.",
    },
    dashboard: {
      title_client: "My Projects",
      title_freelancer: "Available Projects",
      sub_client: "Manage the projects you created",
      sub_freelancer: "Analyze and quote projects",
      search: "Search projects...",
      filter: "Filter",
      all_categories: "All categories",
      all_complexities: "All complexities",
      reset_filters: "Reset filters",
      empty: "No projects yet",
      no_results: "No results",
      empty_client_hint: "Create your first project.",
      empty_freelancer_hint: "Waiting for new projects.",
      empty_filter_hint: "Try different keywords or filters.",
      new: "New Project",
      offer: "Offer",
      preview_3d: "3D Preview",
      complexity: "Complexity",
      effort: "Effort",
    },
    auth: {
      login_title: "Sign in to continue",
      register_title: "Create a new account",
      tab_login: "Sign in",
      tab_register: "Register",
      name: "Name",
      role: "Role",
      email: "Email",
      password: "Password",
      submit_login: "Sign in",
      submit_register: "Create account",
      or: "or",
      google: "Sign in with Google",
      forgot: "Forgot password?",
      terms_pre: "I have read the",
      terms_link: "Terms of Use",
      terms_post: "and fully accept them.",
      terms_required: "Please accept the Terms of Use to continue.",
      err_name: "Please enter your name.",
    },
    contractor_types: {
      label: "Contractor type",
      hint: "What kind of contractor are you?",
      freelancer: "Freelancer",
      unternehmen: "Company",
      mitarbeiter_auftraggeber: "Client employee",
      andere: "Other",
    },
    contact: {
      badge: "Contact & Imprint",
      title_a: "Talk to us –",
      title_b: "we’re listening.",
      lead: "Questions, feedback, bugs, partnership requests? Whether you’re a client or contractor – we usually reply within 48 hours.",
      imprint_label: "Imprint",
      imprint_title: "Owner & Operator",
      owner: "Owner",
      address: "Address",
      email: "Email",
      phone: "Phone",
      legal: "Responsible for content under Swiss law. All information without warranty.",
      form_title: "Message to the operator",
      form_sub: "For clients and contractors alike. We respond to every request.",
      name: "Name",
      i_am: "I am …",
      subject: "Subject",
      subject_ph: "What’s it about?",
      message: "Message",
      message_ph: "Describe your request as precisely as possible…",
      submit: "Send message",
      success_t: "Thanks! Your message has been sent.",
      success_d: "We’ll get back to you via email within 48 hours.",
      error: "Sending failed. Please try again.",
    },
    footer: {
      tagline: "From text briefing to 3D wireframe in seconds. No more vague scopes.",
      nav_label: "Navigation",
      operator: "Operator",
      imprint: "Imprint",
      terms: "Terms of Use",
    },
    notif: {
      title: "Notifications",
      new: "new",
      mark_all: "Mark all read",
      empty: "No notifications",
      empty_sub: "New activity will appear here",
      loading: "Loading...",
      time_now: "just now",
      time_min: "{n} min ago",
      time_hour: "{n} h ago",
      time_day: "{n} d ago",
    },
    wizard: { title: "Create New Project", step1: "What should be built?", step2: "Who is it for?", step3: "Describe details", step1_sub: "Choose your project type", step2_sub: "Who will use the application?", step3_sub: "The more detail, the more accurate the analysis", next: "Next", back: "Back", analyze: "Start AI Analysis", title_ph: "e.g. Organic Coffee Shop App", desc_ph: "Describe what the app should do, which features are important...", users_ph: "e.g. End users, employees, administrators", audience: "Target Audience", projectTitle: "Project Title", description: "Project Description", industry: "Industry", industry_hint: "for compliance pass", industry_auto: "Auto-detect (recommended)", ind_banking: "Banking / Financial Services", ind_insurance: "Insurance", ind_healthcare: "Healthcare / Medical", ind_pharma: "Pharma / Life Sciences", ind_government: "Government / Public Sector / Defense", ind_energy: "Energy / Critical Infrastructure (KRITIS)", ind_telecom: "Telecom / Telecommunications", ind_retail: "Retail / E-Commerce", ind_manufacturing: "Manufacturing / Industry", ind_logistics: "Logistics / Transport", ind_education: "Education", ind_media: "Media / Entertainment", ind_real_estate: "Real Estate", ind_consulting: "Consulting / Services", ind_other: "Other / Non-regulated" },
    project: { back: "Back to Dashboard", edit: "Edit", pdf: "PDF", delete_confirm: "Really delete this project?", "3d_title": "3D Project Preview", ar: "AR Camera", analysis: "Analysis Dashboard", complexity: "Complexity", hours: "Estimated Effort", hours_unit: "Hours", techstack: "Recommended Tech Stack", elements: "Visual Elements", screens: "Screens", functions: "Functions" },
    viz: { intro_title: "What does this preview show?", intro_text: "This analysis shows all building blocks that need to be developed for this project.", cyan_label: "Cyan rectangles", orange_label: "Orange cubes", cyan_desc: "= pages the user sees,", orange_desc: "= technology running invisibly in the background.", zoom: "Scroll: Zoom | Drag: Rotate", screens_count: "Pages users see", backend_count: "Background systems", total: "Total components", journey_title: "How the user navigates through the app", journey_sub: "The typical user path from start to finish:", frontend_title: "What the user sees", frontend_sub: "Pages and screens of the application", backend_title: "What runs in the background", backend_sub: "Invisible technology, databases and logic", connection: "How it all connects:", connection_text: "Each page (above) communicates with the background systems (below) to load, save and process data." },
    cost: { title: "Cost Breakdown per Component", sub: "Detailed hour estimate for each component", component: "Component", hours: "Hours", complexity: "Effort", total: "Total" },
    risk: { title: "Risk Analysis", sub: "Potential challenges and risks", high: "High", medium: "Medium", low: "Low" },
    milestone: { title: "Milestone Planning", sub: "Project phases and timeline", phase: "Phase", weeks: "Weeks", components: "Included Components", total_weeks: "Total Duration" },
    calc: { title: "Calculator", rate: "Your Hourly Rate (EUR)", avg: "Average Hours", rate_label: "Hourly Rate", total: "Total Price", send_offer: "Send offer based on analysis", offer_sent: "Offer sent successfully!" },
    preview2d: { title: "UI Preview", subtitle: "Zero-cost CSS wireframe — no AI generation", tab_landing: "Landing", tab_dashboard: "Dashboard", tab_detail: "Detail", tab_form: "Form", mode_desktop: "Desktop", mode_mobile: "Mobile", cta_show: "View UI preview (first inspiration)", cta_hide: "Hide", cta_open: "Open", disclaimer: "AI-generated visualization of your app. This preview is meant as an <strong>inspiration anchor</strong>, not a mandatory spec. Your contractor will turn it into a final design that fits your needs technically and visually." },
    chat: { title: "Project Chat", empty: "No messages yet. Start the conversation!", input: "Write a message..." },
  },
  fr: {
    lang: "Francais",
    nav: { home: "Accueil", dashboard: "Tableau de bord", newProject: "Nouveau projet", profile: "Profil", contact: "Contact", login: "Connexion", logout: "Deconnexion", notifications: "Notifications", browse: "Voir les projets" },
    roles: { client: "Client", freelancer: "Prestataire", other: "Autre" },
    landing: {
      badge: "Project Radar AR",
      hero: "Du briefing texte a une feuille de route entreprise « Deal-Ready » en quelques secondes.",
      hero_bevor: "Deal-Ready",
      sub: "Entre une vision IT sous forme d'idee (app, plateforme IA, module CRM, migration cloud …) et un devis de realisation concret, les entreprises perdent des semaines. Briefing, architecture, budget, conformite — chaque etape dans un outil different, avec une equipe differente. Nous appelons ca la « faille de discovery ».",
      sub2: "Project Radar AR comble la faille. Un simple texte — et notre IA livre en 90 secondes tout ce dont vous avez besoin pour conclure le deal.",
      output_title: "Votre livraison complete apres 90 secondes :",
      bullets: [
        { title: "Resume executif & jalons", desc: "Un resume management concis et un plan de jalons clair dans le temps, qui structure d'un coup d'oeil l'avancement de votre projet." },
        { title: "Architecture 3D interactive", desc: "Un apercu visuel haute fidelite en volume, qui rend immediatement tangibles les composants frontend et les pipelines de donnees backend complexes." },
        { title: "Calcul precis", desc: "Une ventilation horaire et financiere entierement automatisee et detaillee, pour une transparence budgetaire immediate." },
        { title: "Compliance-native & mapping cloud", desc: "Une analyse de risque integree (p. ex. nDSG/RGPD) avec calcul automatique d'un buffer d'audit reglementaire et des propositions d'architecture cloud natives et optimisees (p. ex. Google Cloud Platform)." },
        { title: "Technologies & stack systeme recommandes", desc: "Le systeme analyse vos exigences et les mappe directement sur la stack technique optimale et durable (bases de donnees, frameworks, APIs)." },
        { title: "Parcours utilisateur optimal", desc: "Un plan de parcours logiquement structure qui definit etape par etape le cheminement de l'utilisateur final dans votre app ou plateforme." },
        { title: "Smart contracting & collaboration", desc: "Generation automatique d'un contrat B2B pret a signer ainsi qu'un outil interactif pour affiner conjointement la solution IT entre client et prestataire." },
      ],
      pill_exec: "Resume executif",
      pill_3d: "Architecture 3D",
      pill_cost: "Ventilation des couts",
      pill_compliance: "Buffer conformite",
      pill_contract: "Smart Contract",
      cta_login: "Demarrer",
      cta_new: "Creer un projet",
      cta_dashboard: "Ouvrir le tableau de bord",
      problem_label: "Le Probleme",
      problem_title_a: "La discovery coute des semaines.",
      problem_title_b: "Nous la reduisons a des minutes.",
      problem_text: "« Il nous faut un module CRM. » — Ce qui suit : 8 reunions, 3 devis, 5 fichiers Excel, 2 avis juridiques. A la fin, chacun parle d'autre chose. Le deal refroidit, la confiance s'effrite. Et personne n'a vu la moindre ligne de code.",
      solution_label: "La Solution",
      solution_title_a: "Decrivez-la.",
      solution_title_b: "Visualisez-la.",
      solution_title_c: "Vendez-la.",
      solution_text: "Votre vision IT sous forme de texte — notre IA en orchestre une architecture 3D interactive, un chiffrage, un controle de conformite et une trame contractuelle. Dans la meme session, en un instant. Prete a signer.",
      value_label: "La Valeur",
      value_title_a: "Un outil,",
      value_title_b: "deux gagnants.",
      client_badge: "Pour les clients",
      client_title: "Clarte du perimetre des le depart",
      client_b1_t: "Voyez ce que vous decrivez",
      client_b1_d: "Votre demande textuelle est visualisee instantanement – vous voyez d'un coup d'oeil si vous avez besoin de 7 pages ou de 5.",
      client_b2_t: "Moins de malentendus",
      client_b2_d: "Le modele visuel partage assure que vous et votre prestataire parlez du meme produit.",
      client_b3_t: "Offres plus precises",
      client_b3_d: "Des calculs bases sur les donnees plutot que des estimations intuitives – vous comparez les offres de facon juste et transparente.",
      client_b4_t: "Continuer ensemble",
      client_b4_d: "Du briefing au produit fini – vous et votre prestataire iterez dans le meme modele 3D, avec demandes de modification et chat en direct. Fini le ping-pong d'e-mails.",
      free_badge: "Pour les prestataires",
      free_title: "Chiffrez plus vite, gagnez plus",
      free_b1_t: "Evaluation instantanee du perimetre",
      free_b1_d: "Au lieu de lire un briefing de 30 minutes – voyez ecrans, fonctions et complexite dans un modele 3D en quelques secondes.",
      free_b2_t: "Calcul base sur les donnees",
      free_b2_d: "Des metadonnees structurees (nombre d'ecrans, complexite, heures) alimentent directement votre offre.",
      free_b3_t: "Meilleur taux de conversion",
      free_b3_d: "Des offres plus rapides et plus precises signifient plus de projets gagnes – et moins de temps d'acquisition perdu.",
      free_b4_t: "Collaboration directe",
      free_b4_d: "Vous travaillez main dans la main avec le client dans le meme modele 3D – demandes de modification, chat en direct, iterations claires. De la clarte plutot que des suppositions, a tout moment.",
      feat_1_t: "Apercu 3D du projet",
      feat_1_d: "Des wireframes interactifs basse-fidelite revelent l'ampleur du projet en un clin d'oeil.",
      feat_2_t: "Analyse par IA",
      feat_2_d: "Detection automatique de la complexite, du stack technique et de l'effort estime.",
      feat_3_t: "Chiffrage precis",
      feat_3_d: "Chiffrez sur la base de donnees plutot que d'intuition.",
      cats_label: "Universal Solution Architect",
      cats_title_a: "Planifie avec nous :",
      cats_title_b: "Apps · Cloud · IA · Securite · Integration.",
      cats_sub: "Project Radar AR ne se limite pas aux apps. Nous planifions toute la transformation numerique de ton entreprise — securisee juridiquement et visualisee en 3D/AR.",
      cat_web_t: "Application Web", cat_web_d: "Site web, Tableau de bord, E-Commerce, SaaS",
      cat_mobile_t: "Application Mobile", cat_mobile_d: "iOS, Android, React Native, Flutter",
      cat_3d_t: "Projet 3D / CAO", cat_3d_d: "Modelisation 3D, Visualisation, AR/VR",
      cat_cloud_t: "Migration Cloud", cat_cloud_d: "Legacy → cloud-native, reprise apres sinistre, consolidation DB",
      cat_ai_t: "Data & AI Hub", cat_ai_d: "Data warehouse, agents IA custom, plateforme IoT",
      cat_sec_t: "Securite & Conformite", cat_sec_d: "Audit ISO / RGPD / SOC2, durcissement cybersecurite, IAM",
      cat_int_t: "Integration Entreprise", cat_int_d: "Connecteurs ERP / CRM, automatisation des workflows (iPaaS)",
      cat_more_t: "Autres projets", cat_more_d: "Decris ton projet — l'IA s'adapte. Toute industrie, tout stack technique.",
      cats_cta_label: "Pret ?",
      cats_cta_text: "Choisis ta categorie et obtiens une feuille de route IA complete en 60 secondes.",
      cats_cta_btn: "Demarrer le projet",
      deliv_label: "Ce que vous obtenez",
      deliv_title_a: "Un rapport IA remplace",
      deliv_title_b: "10 appels de briefing.",
      deliv_sub: "Chaque projet livre instantanement un dossier de cadrage complet — 12 blocs pour la clarte, le chiffrage et la signature.",
      deliv: [
        { t: "Resume executif", d: "5–7 phrases en prose : quels travaux concrets, dans quel ordre, pour atteindre l'objectif." },
        { t: "Apercu 3D du projet", d: "Architecture Three.js interactive avec separation claire frontend/backend, prete pour l'AR via QR code." },
        { t: "Parcours utilisateur", d: "User journey pas a pas avec ecrans numerotes — du lancement a l'objectif." },
        { t: "Ce que voit l'utilisateur", d: "Composants frontend (plans cyan) avec description et heures par ecran." },
        { t: "Ce qui tourne en arriere-plan", d: "Modules backend (cubes oranges) : APIs, bases, services — chacun avec heures et jours estimes." },
        { t: "Stack technique recommande", d: "Proposition concrete de stack (frameworks, BDD, langages) adaptee aux exigences." },
        { t: "Repartition des couts", d: "Budget heures detaille par composant avec niveau de complexite — base de votre devis." },
        { t: "Analyse des risques", d: "2–5 risques concrets (performance, conformite, APIs externes) notes Bas / Moyen / Haut." },
        { t: "Charge reglementaire", d: "Detection de secteur (FINMA, HIPAA, MDR …) incl. multiplicateur d'audit et avertissement de divergence." },
        { t: "Architecture Cloud (GCP)", d: "Mapping de services natifs par composant — Apigee, Cloud KMS, Spanner, Cloud Run, etc." },
        { t: "Planning des jalons", d: "3–5 phases avec semaines, composants inclus et phase d'audit comme chemin critique." },
        { t: "Calendrier projet (Gantt)", d: "Barre de Gantt visuelle avec date de livraison, jours-personne et couleurs par phase." },
      ],
      contract_label: "En plus : Smart Contracts",
      contract_title: "Contrats en un clic",
      contract_sub: "PDF et Word avec clauses specifiques a la juridiction integrees (Suisse, RGPD UE, Rome I, droits IP) — generes directement depuis le dossier de cadrage.",
      contract_b1: "Export PDF et DOCX",
      contract_b2: "Clauses automatiques par pays",
      contract_b3: "Pret a signer",
      sponsor_label: "Soutenez-nous",
      sponsor_title: "Project Radar AR est — et reste — gratuit.",
      sponsor_sub: "Nous voulons faire avancer les projets IT dans le monde entier — sans abonnement premium, sans couts caches. Notre objectif : une collaboration juste, directe et transparente entre clients et prestataires.",
      sponsor_b1: "Gratuit pour tout le monde",
      sponsor_b2: "Aucune commission de plateforme",
      sponsor_b3: "Ouvert a toute industrie, toute taille, tout pays",
      sponsor_cta_text: "Pour que cela reste ainsi, chaque contribution compte — que ce soit 5€, 50€ ou 500€. Chaque don nous aide a maintenir, faire evoluer et garder la plateforme independante.",
      sponsor_button: "Soutenir via PayPal",
      sponsor_thanks: "Merci de soutenir un marche IT equitable.",
    },
    dashboard: {
      title_client: "Mes Projets",
      title_freelancer: "Projets Disponibles",
      sub_client: "Gerez les projets que vous avez crees",
      sub_freelancer: "Analysez et chiffrez des projets",
      search: "Rechercher des projets...",
      filter: "Filtrer",
      all_categories: "Toutes les categories",
      all_complexities: "Toutes les complexites",
      reset_filters: "Reinitialiser les filtres",
      empty: "Aucun projet",
      no_results: "Aucun resultat",
      empty_client_hint: "Creez votre premier projet.",
      empty_freelancer_hint: "En attente de nouveaux projets.",
      empty_filter_hint: "Essayez d'autres mots-cles ou filtres.",
      new: "Nouveau Projet",
      offer: "Offre",
      preview_3d: "Apercu 3D",
      complexity: "Complexite",
      effort: "Effort",
    },
    contractor_types: {
      label: "Type de prestataire",
      hint: "Quel type de prestataire es-tu ?",
      freelancer: "Freelance",
      unternehmen: "Entreprise",
      mitarbeiter_auftraggeber: "Employé du client",
      andere: "Autre",
    },
    contact: {
      badge: "Contact & Mentions legales",
      title_a: "Parlez-nous –",
      title_b: "nous ecoutons.",
      lead: "Questions, retours, bugs, demandes de partenariat ? Client ou prestataire – nous repondons generalement sous 48 heures.",
      imprint_label: "Mentions legales",
      imprint_title: "Proprietaire & Exploitant",
      owner: "Proprietaire",
      address: "Adresse",
      email: "Email",
      phone: "Telephone",
      legal: "Responsable du contenu selon le droit suisse. Informations fournies sans garantie.",
      form_title: "Message a l'exploitant",
      form_sub: "Pour clients et prestataires. Nous repondons a chaque demande.",
      name: "Nom",
      i_am: "Je suis …",
      subject: "Sujet",
      subject_ph: "De quoi s'agit-il ?",
      message: "Message",
      message_ph: "Decrivez votre demande aussi precisement que possible…",
      submit: "Envoyer le message",
      success_t: "Merci ! Votre message a ete envoye.",
      success_d: "Nous vous repondrons par email sous 48 heures.",
      error: "Echec de l'envoi. Veuillez reessayer.",
    },
    footer: {
      tagline: "Du briefing texte au wireframe 3D en quelques secondes. Finis les perimetres flous.",
      nav_label: "Navigation",
      operator: "Exploitant",
      imprint: "Mentions legales",
      terms: "Conditions d'utilisation",
    },
    notif: {
      title: "Notifications",
      new: "nouv.",
      mark_all: "Tout marquer lu",
      empty: "Aucune notification",
      empty_sub: "Les nouvelles activites apparaitront ici",
      loading: "Chargement...",
      time_now: "a l'instant",
      time_min: "il y a {n} min",
      time_hour: "il y a {n} h",
      time_day: "il y a {n} j",
    },
    wizard: { title: "Creer un Nouveau Projet", step1: "Que faut-il construire?", step2: "Pour qui?", step3: "Decrire les details", step1_sub: "Choisissez le type de projet", step2_sub: "Qui utilisera l'application?", step3_sub: "Plus de details, plus precise l'analyse", next: "Suivant", back: "Retour", analyze: "Lancer l'analyse IA", title_ph: "ex. Application Bio Coffee Shop", desc_ph: "Decrivez ce que l'app doit faire...", users_ph: "ex. Clients, employes, administrateurs", audience: "Public Cible", projectTitle: "Titre du Projet", description: "Description du Projet", industry: "Secteur", industry_hint: "pour le pass conformite", industry_auto: "Detection automatique (recommande)", ind_banking: "Banque / Services Financiers", ind_insurance: "Assurance", ind_healthcare: "Sante / Medical", ind_pharma: "Pharma / Sciences de la Vie", ind_government: "Gouvernement / Secteur Public / Defense", ind_energy: "Energie / Infrastructure Critique (KRITIS)", ind_telecom: "Telecom / Telecommunications", ind_retail: "Retail / E-Commerce", ind_manufacturing: "Manufacture / Industrie", ind_logistics: "Logistique / Transport", ind_education: "Education", ind_media: "Media / Divertissement", ind_real_estate: "Immobilier", ind_consulting: "Conseil / Services", ind_other: "Autre / Non regule" },
    project: { back: "Retour au tableau de bord", edit: "Modifier", pdf: "PDF", delete_confirm: "Supprimer ce projet?", "3d_title": "Apercu 3D du Projet", ar: "Camera AR", analysis: "Tableau d'Analyse", complexity: "Complexite", hours: "Effort Estime", hours_unit: "Heures", techstack: "Stack Technique Recommande", elements: "Elements Visuels", screens: "Ecrans", functions: "Fonctions" },
    viz: { intro_title: "Que montre cet apercu?", intro_text: "Cette analyse montre tous les composants a developper pour ce projet.", cyan_label: "Rectangles cyan", orange_label: "Cubes orange", cyan_desc: "= pages visibles par l'utilisateur,", orange_desc: "= technologie invisible en arriere-plan.", zoom: "Molette: Zoom | Glisser: Rotation", screens_count: "Pages visibles", backend_count: "Systemes en arriere-plan", total: "Composants au total", journey_title: "Navigation de l'utilisateur", journey_sub: "Le parcours type de l'utilisateur:", frontend_title: "Ce que l'utilisateur voit", frontend_sub: "Pages et ecrans de l'application", backend_title: "Ce qui tourne en arriere-plan", backend_sub: "Technologie, bases de donnees et logique", connection: "Comment tout est connecte:", connection_text: "Chaque page communique avec les systemes en arriere-plan pour charger et traiter les donnees." },
    cost: { title: "Ventilation des Couts", sub: "Estimation detaillee par composant", component: "Composant", hours: "Heures", complexity: "Effort", total: "Total" },
    risk: { title: "Analyse des Risques", sub: "Defis et risques potentiels", high: "Eleve", medium: "Moyen", low: "Faible" },
    milestone: { title: "Planification des Jalons", sub: "Phases et calendrier du projet", phase: "Phase", weeks: "Semaines", components: "Composants Inclus", total_weeks: "Duree Totale" },
    calc: { title: "Calculateur", rate: "Votre taux horaire (EUR)", avg: "Heures moyennes", rate_label: "Taux horaire", total: "Prix Total", send_offer: "Envoyer l'offre", offer_sent: "Offre envoyee!" },
    preview2d: { title: "Apercu UI", subtitle: "Wireframe CSS sans cout — pas de generation IA", tab_landing: "Accueil", tab_dashboard: "Tableau de bord", tab_detail: "Detail", tab_form: "Formulaire", mode_desktop: "Bureau", mode_mobile: "Mobile", cta_show: "Voir l'apercu UI (premiere inspiration)", cta_hide: "Masquer", cta_open: "Ouvrir", disclaimer: "Visualisation generee par IA de ton app. Cet apercu sert d'<strong>ancre d'inspiration</strong>, pas de cahier des charges. Ton prestataire en fera un design final adapte techniquement et visuellement a tes besoins." },
    chat: { title: "Chat Projet", empty: "Pas encore de messages.", input: "Ecrire un message..." },
  },
  es: {
    lang: "Espanol",
    nav: { home: "Inicio", dashboard: "Panel", newProject: "Nuevo proyecto", profile: "Perfil", contact: "Contacto", login: "Iniciar sesion", logout: "Cerrar sesion", notifications: "Notificaciones", browse: "Ver proyectos" },
    roles: { client: "Cliente", freelancer: "Contratista", other: "Otro" },
    landing: {
      badge: "Project Radar AR",
      hero: "Del briefing de texto a una hoja de ruta «Deal-Ready» en segundos.",
      hero_bevor: "Deal-Ready",
      sub: "Entre una vision IT como idea (app, plataforma de IA, modulo CRM, migracion a la nube …) y una oferta concreta de implementacion, las empresas pierden semanas. Briefing, arquitectura, presupuesto, cumplimiento — cada paso en una herramienta distinta, con un equipo distinto. Lo llamamos la «brecha de discovery».",
      sub2: "Project Radar AR cierra la brecha. Un input de texto — y nuestra IA entrega, en 90 segundos, todo lo que necesitas para cerrar el trato.",
      output_title: "Tu output de proyecto completo en 90 segundos:",
      bullets: [
        { title: "Resumen ejecutivo & hitos", desc: "Un resumen de management conciso y un plan de hitos claro en el tiempo, que estructura el avance de tu proyecto de un vistazo." },
        { title: "Arquitectura 3D interactiva", desc: "Una vista previa visual de alta fidelidad en el espacio, que hace tangibles al instante los componentes frontend y los pipelines de datos backend complejos." },
        { title: "Calculo preciso", desc: "Un desglose de horas y costes detallado y totalmente automatizado, que entrega transparencia presupuestaria inmediata." },
        { title: "Compliance-native & mapeo cloud", desc: "Un analisis de riesgo integrado (p. ej. nDSG/RGPD) con calculo automatico de un buffer regulatorio de auditoria y propuestas de arquitectura cloud nativas y optimizadas (p. ej. Google Cloud Platform)." },
        { title: "Tecnologias y stack del sistema recomendados", desc: "El sistema analiza tus requisitos y los mapea directamente al stack tecnologico optimo y a prueba de futuro (bases de datos, frameworks, APIs)." },
        { title: "Flujo de usuario optimo", desc: "Un plan de flujo logicamente estructurado que define paso a paso el recorrido del usuario final por tu app o plataforma." },
        { title: "Smart contracting & colaboracion", desc: "Generacion automatica de un contrato B2B listo para firmar y una herramienta interactiva para afinar la solucion IT conjuntamente entre cliente y contratista." },
      ],
      pill_exec: "Resumen ejecutivo",
      pill_3d: "Arquitectura 3D",
      pill_cost: "Desglose de costes",
      pill_compliance: "Buffer de cumplimiento",
      pill_contract: "Smart Contract",
      cta_login: "Empezar",
      cta_new: "Crear proyecto",
      cta_dashboard: "Abrir panel",
      problem_label: "El Problema",
      problem_title_a: "La discovery cuesta semanas.",
      problem_title_b: "Nosotros la convertimos en minutos.",
      problem_text: "«Necesitamos un modulo CRM.» — Lo que sigue: 8 reuniones, 3 ofertas, 5 hojas Excel, 2 revisiones legales. Al final, cada uno habla de algo distinto. El trato se enfria, la confianza se rompe. Y nadie ha visto ni una linea de codigo.",
      solution_label: "La Solucion",
      solution_title_a: "Describelo.",
      solution_title_b: "Vealo.",
      solution_title_c: "Vendelo.",
      solution_text: "Tu vision IT como texto — nuestra IA orquesta una arquitectura 3D interactiva, calculo de costes, comprobacion de cumplimiento y borrador de contrato. En la misma sesion en la que la escribes. Listo para firmar.",
      value_label: "El Valor",
      value_title_a: "Una herramienta,",
      value_title_b: "dos ganadores.",
      client_badge: "Para clientes",
      client_title: "Claridad de alcance desde el inicio",
      client_b1_t: "Ve lo que describes",
      client_b1_d: "Tu requerimiento textual se visualiza al instante – ves de un vistazo si necesitas 7 pantallas o solo 5.",
      client_b2_t: "Menos malentendidos",
      client_b2_d: "El modelo visual compartido garantiza que tu y tu contratista hablais del mismo producto.",
      client_b3_t: "Ofertas mas precisas",
      client_b3_d: "Calculos basados en datos en lugar de estimaciones a ojo – compara ofertas de forma justa y transparente.",
      client_b4_t: "Seguir construyendo juntos",
      client_b4_d: "Del briefing al producto final – tu y tu contratista iterais en el mismo modelo 3D, con solicitudes de cambio y chat en vivo. Adios al ping-pong de e-mails.",
      free_badge: "Para contratistas",
      free_title: "Cotiza mas rapido, gana mas",
      free_b1_t: "Evaluacion instantanea de alcance",
      free_b1_d: "En lugar de leer un briefing de 30 minutos – ves pantallas, funciones y complejidad en un modelo 3D en segundos.",
      free_b2_t: "Calculo basado en datos",
      free_b2_d: "Metadatos estructurados (pantallas, complejidad, horas) alimentan tu oferta directamente.",
      free_b3_t: "Mayor tasa de exito",
      free_b3_d: "Ofertas mas rapidas y precisas significan mas proyectos ganados – y menos tiempo de captacion perdido.",
      free_b4_t: "Colaboracion directa",
      free_b4_d: "Trabajas codo a codo con el cliente en el mismo modelo 3D – solicitudes de cambio, chat en vivo, iteraciones claras. Claridad en lugar de suposiciones, en todo momento.",
      feat_1_t: "Vista 3D del proyecto",
      feat_1_d: "Wireframes interactivos de baja fidelidad revelan el alcance a simple vista.",
      feat_2_t: "Analisis con IA",
      feat_2_d: "Deteccion automatica de complejidad, stack tecnico y esfuerzo estimado.",
      feat_3_t: "Cotizacion precisa",
      feat_3_d: "Cotiza basandote en datos en lugar de intuicion.",
      cats_label: "Universal Solution Architect",
      cats_title_a: "Planifica con nosotros:",
      cats_title_b: "Apps · Nube · IA · Seguridad · Integracion.",
      cats_sub: "Project Radar AR no es solo para apps. Planificamos toda la transformacion digital de tu empresa — con seguridad juridica y visualizada en 3D/AR.",
      cat_web_t: "Aplicacion Web", cat_web_d: "Sitio web, Panel, E-Commerce, SaaS",
      cat_mobile_t: "App Movil", cat_mobile_d: "iOS, Android, React Native, Flutter",
      cat_3d_t: "Proyecto 3D / CAD", cat_3d_d: "Modelado 3D, Visualizacion, AR/VR",
      cat_cloud_t: "Migracion a la Nube", cat_cloud_d: "Legacy → cloud-native, recuperacion ante desastres, consolidacion BBDD",
      cat_ai_t: "Data & AI Hub", cat_ai_d: "Data warehouse, agentes IA personalizados, plataforma IoT",
      cat_sec_t: "Seguridad y Cumplimiento", cat_sec_d: "Auditoria ISO / RGPD / SOC2, hardening de ciberseguridad, IAM",
      cat_int_t: "Integracion Empresarial", cat_int_d: "Conectores ERP / CRM, automatizacion de flujos (iPaaS)",
      cat_more_t: "Otros proyectos", cat_more_d: "Describe tu proyecto — la IA se adapta. Cualquier industria, cualquier stack.",
      cats_cta_label: "Listo?",
      cats_cta_text: "Elige tu categoria y obten una hoja de ruta IA completa en 60 segundos.",
      cats_cta_btn: "Iniciar Proyecto",
      deliv_label: "Lo que obtienes",
      deliv_title_a: "Un informe IA reemplaza",
      deliv_title_b: "10 llamadas de briefing.",
      deliv_sub: "Cada proyecto entrega al instante un dossier de scoping completo — 12 bloques para claridad, presupuesto y firma.",
      deliv: [
        { t: "Resumen ejecutivo", d: "5–7 frases en prosa: que trabajos concretos y en que orden son necesarios para alcanzar el objetivo." },
        { t: "Vista 3D del proyecto", d: "Arquitectura Three.js interactiva con clara division frontend/backend, lista para AR via codigo QR." },
        { t: "Flujo de usuario", d: "User journey paso a paso con pantallas numeradas — desde el inicio hasta el objetivo." },
        { t: "Lo que ve el usuario", d: "Componentes frontend (planos cian) con descripcion y horas por pantalla." },
        { t: "Lo que corre en segundo plano", d: "Modulos backend (cubos naranjas): APIs, bases de datos, servicios — cada uno con horas y dias estimados." },
        { t: "Stack tecnico recomendado", d: "Propuesta concreta de stack (frameworks, bases, lenguajes) adaptada a los requisitos." },
        { t: "Desglose de costes", d: "Presupuesto horario detallado por componente con nivel de complejidad — base de tu cotizacion." },
        { t: "Analisis de riesgos", d: "2–5 riesgos concretos (rendimiento, cumplimiento, APIs externas) calificados Bajo / Medio / Alto." },
        { t: "Sobrecarga regulatoria", d: "Deteccion de sector (FINMA, HIPAA, MDR …) con multiplicador de auditoria y aviso de divergencia." },
        { t: "Arquitectura Cloud (GCP)", d: "Mapeo de servicios nativos por componente — Apigee, Cloud KMS, Spanner, Cloud Run y mas." },
        { t: "Planificacion de hitos", d: "3–5 fases con semanas, componentes incluidos y fase de auditoria como ruta critica." },
        { t: "Cronograma del proyecto (Gantt)", d: "Barra Gantt visual con fecha de entrega, dias-persona y fases con codigo de color." },
      ],
      contract_label: "Ademas: Smart Contracts",
      contract_title: "Contratos con un clic",
      contract_sub: "PDF y Word con clausulas especificas por jurisdiccion incorporadas (Suiza, RGPD UE, Roma I, derechos IP) — generados directamente desde el dossier de scoping.",
      contract_b1: "Exportacion PDF y DOCX",
      contract_b2: "Clausulas automaticas por pais",
      contract_b3: "Listo para firmar",
      sponsor_label: "Apoyanos",
      sponsor_title: "Project Radar AR es — y seguira siendo — gratis.",
      sponsor_sub: "Queremos impulsar los proyectos IT en todo el mundo — sin planes premium, sin costos ocultos. Nuestro objetivo: colaboracion justa, directa y transparente entre clientes y contratistas.",
      sponsor_b1: "Gratis para todos",
      sponsor_b2: "Sin comision de plataforma sobre los proyectos",
      sponsor_b3: "Abierto a cualquier industria, tamano y pais",
      sponsor_cta_text: "Para que siga asi, cada contribucion cuenta — ya sea 5€, 50€ o 500€. Cada donacion nos ayuda a mantener, hacer evolucionar y mantener la plataforma independiente.",
      sponsor_button: "Apoyar via PayPal",
      sponsor_thanks: "Gracias por apoyar un mercado IT justo.",
    },
    dashboard: {
      title_client: "Mis Proyectos",
      title_freelancer: "Proyectos Disponibles",
      sub_client: "Gestiona los proyectos que creaste",
      sub_freelancer: "Analiza y cotiza proyectos",
      search: "Buscar proyectos...",
      filter: "Filtro",
      all_categories: "Todas las categorias",
      all_complexities: "Todas las complejidades",
      reset_filters: "Restablecer filtros",
      empty: "Sin proyectos",
      no_results: "Sin resultados",
      empty_client_hint: "Crea tu primer proyecto.",
      empty_freelancer_hint: "Esperando nuevos proyectos.",
      empty_filter_hint: "Prueba otras palabras clave o filtros.",
      new: "Nuevo Proyecto",
      offer: "Oferta",
      preview_3d: "Vista 3D",
      complexity: "Complejidad",
      effort: "Esfuerzo",
    },
    auth: {
      login_title: "Inicia sesión para continuar",
      register_title: "Crea una cuenta nueva",
      tab_login: "Iniciar sesión",
      tab_register: "Registrarse",
      name: "Nombre",
      role: "Rol",
      email: "Correo electrónico",
      password: "Contraseña",
      submit_login: "Iniciar sesión",
      submit_register: "Crear cuenta",
      or: "o",
      google: "Iniciar sesión con Google",
      forgot: "¿Contraseña olvidada?",
      terms_pre: "He leído los",
      terms_link: "Términos de Uso",
      terms_post: "y los acepto plenamente.",
      terms_required: "Por favor, acepta los Términos de Uso para continuar.",
      err_name: "Por favor, ingresa tu nombre.",
    },
    contractor_types: {
      label: "Tipo de contratista",
      hint: "¿Qué tipo de contratista eres?",
      freelancer: "Freelancer",
      unternehmen: "Empresa",
      mitarbeiter_auftraggeber: "Empleado del cliente",
      andere: "Otro",
    },
    contact: {
      badge: "Contacto y Aviso legal",
      title_a: "Habla con nosotros –",
      title_b: "te escuchamos.",
      lead: "Dudas, feedback, bugs, colaboraciones? Seas cliente o contratista – solemos responder en 48 horas.",
      imprint_label: "Aviso legal",
      imprint_title: "Propietario & Operador",
      owner: "Propietario",
      address: "Direccion",
      email: "Email",
      phone: "Telefono",
      legal: "Responsable del contenido segun la legislacion suiza. Informacion sin garantia.",
      form_title: "Mensaje al operador",
      form_sub: "Para clientes y contratistas. Respondemos cada solicitud.",
      name: "Nombre",
      i_am: "Soy …",
      subject: "Asunto",
      subject_ph: "De que se trata?",
      message: "Mensaje",
      message_ph: "Describe tu solicitud con la mayor precision posible…",
      submit: "Enviar mensaje",
      success_t: "Gracias! Tu mensaje ha sido enviado.",
      success_d: "Te responderemos por email en un plazo de 48 horas.",
      error: "Error al enviar. Intenta de nuevo.",
    },
    footer: {
      tagline: "Del briefing de texto al wireframe 3D en segundos. Adios a los alcances vagos.",
      nav_label: "Navegacion",
      operator: "Operador",
      imprint: "Aviso legal",
      terms: "Términos de Uso",
    },
    notif: {
      title: "Notificaciones",
      new: "nuevas",
      mark_all: "Marcar todas leidas",
      empty: "Sin notificaciones",
      empty_sub: "Las nuevas actividades apareceran aqui",
      loading: "Cargando...",
      time_now: "ahora mismo",
      time_min: "hace {n} min",
      time_hour: "hace {n} h",
      time_day: "hace {n} d",
    },
    wizard: { title: "Crear Nuevo Proyecto", step1: "Que se debe construir?", step2: "Para quien?", step3: "Describir detalles", step1_sub: "Elige el tipo de proyecto", step2_sub: "Quien usara la aplicacion?", step3_sub: "Mas detalles, mas preciso el analisis", next: "Siguiente", back: "Atras", analyze: "Iniciar Analisis IA", title_ph: "ej. App Tienda de Cafe Bio", desc_ph: "Describe lo que la app debe hacer...", users_ph: "ej. Clientes, empleados, administradores", audience: "Publico Objetivo", projectTitle: "Titulo del Proyecto", description: "Descripcion del Proyecto", industry: "Sector", industry_hint: "para pase de cumplimiento", industry_auto: "Deteccion automatica (recomendado)", ind_banking: "Banca / Servicios Financieros", ind_insurance: "Seguros", ind_healthcare: "Salud / Medico", ind_pharma: "Farmaceutica / Ciencias de la Vida", ind_government: "Gobierno / Sector Publico / Defensa", ind_energy: "Energia / Infraestructura Critica (KRITIS)", ind_telecom: "Telecom / Telecomunicaciones", ind_retail: "Retail / E-Commerce", ind_manufacturing: "Manufactura / Industria", ind_logistics: "Logistica / Transporte", ind_education: "Educacion", ind_media: "Media / Entretenimiento", ind_real_estate: "Inmobiliaria", ind_consulting: "Consultoria / Servicios", ind_other: "Otro / No regulado" },
    project: { back: "Volver al panel", edit: "Editar", pdf: "PDF", delete_confirm: "Eliminar este proyecto?", "3d_title": "Vista 3D del Proyecto", ar: "Camara AR", analysis: "Panel de Analisis", complexity: "Complejidad", hours: "Esfuerzo Estimado", hours_unit: "Horas", techstack: "Stack Recomendado", elements: "Elementos Visuales", screens: "Pantallas", functions: "Funciones" },
    viz: { intro_title: "Que muestra esta vista?", intro_text: "Este analisis muestra todos los componentes que deben desarrollarse.", cyan_label: "Rectangulos cyan", orange_label: "Cubos naranja", cyan_desc: "= paginas que ve el usuario,", orange_desc: "= tecnologia invisible en segundo plano.", zoom: "Rueda: Zoom | Arrastrar: Rotar", screens_count: "Paginas visibles", backend_count: "Sistemas de fondo", total: "Componentes totales", journey_title: "Navegacion del usuario", journey_sub: "El recorrido tipico del usuario:", frontend_title: "Lo que el usuario ve", frontend_sub: "Paginas y pantallas de la aplicacion", backend_title: "Lo que corre en segundo plano", backend_sub: "Tecnologia, bases de datos y logica", connection: "Como se conecta todo:", connection_text: "Cada pagina se comunica con los sistemas de fondo para cargar y procesar datos." },
    cost: { title: "Desglose de Costos", sub: "Estimacion detallada por componente", component: "Componente", hours: "Horas", complexity: "Esfuerzo", total: "Total" },
    risk: { title: "Analisis de Riesgos", sub: "Desafios y riesgos potenciales", high: "Alto", medium: "Medio", low: "Bajo" },
    milestone: { title: "Planificacion de Hitos", sub: "Fases y cronograma del proyecto", phase: "Fase", weeks: "Semanas", components: "Componentes Incluidos", total_weeks: "Duracion Total" },
    calc: { title: "Calculadora", rate: "Tu tarifa por hora (EUR)", avg: "Horas promedio", rate_label: "Tarifa", total: "Precio Total", send_offer: "Enviar oferta", offer_sent: "Oferta enviada!" },
    preview2d: { title: "Vista previa UI", subtitle: "Wireframe CSS sin coste — sin generacion IA", tab_landing: "Inicio", tab_dashboard: "Panel", tab_detail: "Detalle", tab_form: "Formulario", mode_desktop: "Escritorio", mode_mobile: "Movil", cta_show: "Ver vista previa UI (primera inspiracion)", cta_hide: "Ocultar", cta_open: "Abrir", disclaimer: "Visualizacion generada por IA de tu app. Esta vista previa sirve como <strong>ancla de inspiracion</strong>, no como especificacion obligatoria. Tu contratista la convertira en un diseno final que encaje tecnica y visualmente con tus necesidades." },
    chat: { title: "Chat del Proyecto", empty: "Sin mensajes aun.", input: "Escribe un mensaje..." },
  },
};

const LangContext = createContext();
const STORAGE_KEY = "radar_lang";

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try {
      const saved = typeof window !== "undefined" ? window.localStorage.getItem(STORAGE_KEY) : null;
      if (saved && translations[saved]) return saved;
    } catch (_) {
      /* ignore */
    }
    return "de";
  });

  const setLang = (code) => {
    if (!translations[code]) return;
    setLangState(code);
    try {
      window.localStorage.setItem(STORAGE_KEY, code);
    } catch (_) {
      /* ignore */
    }
  };

  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const t = translations[lang] || translations.de;
  const languages = Object.keys(translations).map((k) => ({ code: k, name: translations[k].lang }));

  return (
    <LangContext.Provider value={{ lang, setLang, t, languages }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be within LangProvider");
  return ctx;
}
